module.exports = __webpack_public_path__ + "static/media/wissam.171a77d0.jpg";